module.exports = __webpack_public_path__ + "img/baby_woman.5a14612e.png";